import styled from 'styled-components';

export const PageContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ClefSelector = styled.select`
  font-size: 16px;
  margin-top: 10px;
`;
